var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isFinish && !_vm.props.selectedContent ? _c('div', {
    staticClass: "form-input-container"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(" " + _vm._s(_vm.props.title) + " ")]), _c('div', {
    staticClass: "form-input-box"
  }, [_c('div', {
    staticClass: "form-input-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    class: ['form-input', _vm.isH5 ? 'form-input-h5' : ''],
    attrs: {
      "placeholder": _vm.TUITranslateService.t('AIDesk.请输入内容')
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value;
      }
    }
  }), _vm.validator ? _c('div', {
    staticClass: "validator-line"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.请填写必填项")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "submit-icon",
    on: {
      "click": function ($event) {
        return _vm.submitForm();
      }
    }
  }, [_c('Icon', {
    attrs: {
      "src": _vm.iconSend,
      "width": "30px",
      "height": "30px"
    }
  })], 1)])]) : _vm.isFinish || _vm.props.selectedContent ? _c('div', {
    staticClass: "form-finish-container"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.props.title) + " ")]), _c('div', {
    staticClass: "form-finish-title-right"
  }, [_c('Icon', {
    staticStyle: {
      "margin": "0px 4px"
    },
    attrs: {
      "src": _vm.iconSucess
    }
  }), _vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.已提交")) + " ")], 1)]), _c('div', [_vm._v(" " + _vm._s(_vm.props.selectedContent || _vm.text) + " ")])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }